import { FiltersTypes } from "@common/types/filters/general";
import { View } from "@common/types/views/views";
import { ColumnSettings } from "@design-system/ViewToolbar/ColumnSettings";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import {
    FilterTabs,
    FiltersChangeFn,
} from "@components/pageHeader/filters/lib";
import { applyCoaTemplateEntitySelectionViewConfig } from "../apply/applyCoaTemplateEntitySelectionViewConfig";
import { appliedEntitiesDrawerView } from "./appliedEntitiesDrawerView.constants";

const defaultFilters: FiltersTypes = {};

const availableFilters: FilterTabs[] = [
    FilterTabs.SERVICES,
    FilterTabs.TEAM_MEMBERS,
    FilterTabs.ENTITY_INDUSTRY,
    FilterTabs.ENTITY_BASIS,
    FilterTabs.COA_LAST_UPDATED,
    FilterTabs.COA_APPLIED_AT,
];

interface Props {
    searchFilter: string | undefined;
    onSearchChange: (value: string | undefined) => void;
    filters: FiltersTypes;
    onFiltersChange: FiltersChangeFn;
    view: View;
    onViewChange: (view: View) => void;
}

// Toolbar for the applied-entities drawer. Surfaces Services / Team, Industry,
// Basis, and the two drawer-specific date ranges (Last updated / Applied), plus
// column settings.
export const AppliedEntitiesToolbar = ({
    searchFilter,
    onSearchChange,
    filters,
    onFiltersChange,
    view,
    onViewChange,
}: Props) => (
    <TablePageHeader
        isFullPage
        search={searchFilter}
        onSearchChange={(val) => onSearchChange(val || undefined)}
        filters={filters}
        onFiltersChange={onFiltersChange}
        availableFilters={availableFilters}
        defaultFilters={defaultFilters}
        defaultTab={FilterTabs.SERVICES}
    >
        <ColumnSettings
            view={view}
            viewConfig={applyCoaTemplateEntitySelectionViewConfig}
            defaultView={appliedEntitiesDrawerView}
            onViewChange={onViewChange}
        />
    </TablePageHeader>
);
